import request from '@/common/request/request_product'

function login(data) { return request({ url: '/Tenant/Login', method: 'post', timeout: 20000, data }) }

export default {
  login
}
